
import React, {} from "react";

import {
    Users,
    Settings,
    Clock3,
    CalendarDays,
    ChevronRight,
} from "lucide-react";
import { Helmet } from "react-helmet";

import {useNavigate} from "react-router-dom";

export default function DashboardFieldCard() {
    const navigate = useNavigate();

    return(
        <main>
            <Helmet>
                <title>Dashboard Navigation</title>

                <meta property="og:title" content="Dashboard Navigation" />
            </Helmet>

            <section className="grid grid-cols-1 gap-6 md:grid-cols-2">
                {/* Management Card */}
                <button
                    type="button"
                    onClick={() => navigate("/field")}
                    className="group overflow-hidden rounded-2xl border border-gray-400
          bg-white text-left shadow-sm transition duration-200
          hover:-translate-y-1 hover:shadow-lg
          focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                    <div className="flex min-h-40 items-center justify-center
          bg-gradient-to-br from-gray-400 to-indigo-100 p-8">
                        <div className="relative">
                            <Users size={72} className="text-pink-600" />
                            <Settings
                                size={34}
                                className="absolute -bottom-3 -right-5 rounded-xl
                bg-white p-1.5 text-indigo-600 shadow"
                            />
                        </div>
                    </div>

                    <div className="p-6 sm:p-8">
                        <h2 className="text-2xl font-bold text-slate-900">
                            Field Crew
                        </h2>

                        <p className="mt-2 min-h-12 text-sm leading-6 text-slate-600">
                            Check work hours, timesheets, reports and settings.
                        </p>

                        <div className="mt-6 flex items-center justify-between
            rounded-xl bg-gray-600 px-5 py-3.5 font-semibold text-white
            transition group-hover:bg-gray-700">
                            <span>Go to Field Reports</span>
                            <ChevronRight size={20} />
                        </div>
                    </div>
                </button>

                {/* Clock In / Out Card */}
                <button
                    type="button"
                    onClick={() => navigate("/clockin")}
                    className="group overflow-hidden rounded-2xl border border-emerald-100
          bg-white text-left shadow-sm transition duration-200
          hover:-translate-y-1 hover:shadow-lg
          focus:outline-none focus:ring-2 focus:ring-emerald-500"
                >
                    <div className="flex min-h-40 items-center justify-center
          bg-gradient-to-br from-emerald-200 to-teal-100 p-8">
                        <div className="relative">
                            <Clock3 size={72} className="text-emerald-600" />
                            <CalendarDays
                                size={34}
                                className="absolute -bottom-3 -right-5 rounded-xl
                bg-white p-1.5 text-teal-600 shadow"
                            />
                        </div>
                    </div>

                    <div className="p-6 sm:p-8">
                        <h2 className="text-2xl font-bold text-slate-900">
                            Clock In / Out
                        </h2>

                        <p className="mt-2 min-h-12 text-sm leading-6 text-slate-600">
                            Start or end your work session, select a project, and track
                            your daily hours.
                        </p>

                        <div className="mt-6 flex items-center justify-between
            rounded-xl bg-emerald-600 px-5 py-3.5 font-semibold text-white
            transition group-hover:bg-emerald-700">
                            <span>Go to Clock In</span>
                            <ChevronRight size={20} />
                        </div>
                    </div>
                </button>
            </section>

        </main>
    )
}